import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

export interface SendDialogData {
  isEmail: boolean,
  email: string,
  phone: string,
}

@Component({
  selector: 'send-dialog',
  templateUrl: './send-dialog.component.html',
  styleUrls: ['./send-dialog.component.scss']
})

export class SendDialog {

  faTimes = faTimes;

  sendForm: FormGroup;
  emailFormControl = new FormControl('', [Validators.required, Validators.email]);
  phoneFormControl = new FormControl('', [Validators.required]);

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<SendDialog>,
    @Inject(MAT_DIALOG_DATA) public data: SendDialogData,
  ) {
    this.sendForm = this.formBuilder.group({
      userNameFormControl: this.emailFormControl
    });
  }

  onSendClick(): void {
    this.data.email = this.emailFormControl.value;
    this.data.phone = this.phoneFormControl.value;
    this.dialogRef.close(this.data);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
